var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.guardar_como_presupuesto)?_c('b-col',{staticClass:"check-sale",attrs:{"cols":"12"}},[_c('h2',[_vm._v(" Presupuesto ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }